import { RouteMetadata } from './types';

export const filesMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/files/:bucketName',
        section: 'files',
        view: 'bucket-details',
        descriptionTemplate: 'User is viewing bucket {bucketName}',
        capabilities: [
            'View all files in the bucket',
            'Upload new files',
            'Download files',
            'Delete files',
            'View file metadata',
            'Preview files',
        ],
        hints: [
            'Buckets organize files in cloud storage',
            'Files can be images, documents, videos, or any format',
            'Files can be used in workflows as inputs or outputs',
            'File metadata includes size, type, and custom properties',
        ],
    },
    {
        pattern: '/agents/:agentId/files',
        section: 'files',
        view: 'list',
        descriptionTemplate: 'User is viewing the files list',
        capabilities: [
            'View all storage buckets',
            'Create new buckets',
            'Delete buckets',
            'View bucket storage usage',
        ],
        hints: [
            'Files are organized into buckets',
            'Each bucket has its own access controls',
            'Buckets show total size and file count',
        ],
    },
];
